module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgwIiB3aWR0aD0iNjQwIiB2aWV3Qm94PSIwIDAgNjQwIDQ4MCI+CiAgPGcgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik02NDAuMDA2IDQ3OS45OTRIMFYwaDY0MC4wMDZ6Ii8+CiAgICA8cGF0aCBmaWxsPSIjMzg4ZDAwIiBkPSJNNjQwLjAwNiA0NzkuOTk0SDBWMzE5Ljk5Nmg2NDAuMDA2eiIvPgogICAgPHBhdGggZmlsbD0iI2Q0MzUxNiIgZD0iTTY0MC4wMDYgMTYwLjEyN0gwVi4xM2g2NDAuMDA2eiIvPgogIDwvZz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/hu.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/hu.svg
// module chunks = 0